import { useCallback } from "react";
import { useCurrentUserLocale } from "@linkfluence/core/user/use-cases";
import { tr } from "@radarly/i18n";
import { WizardTemplate } from "@radarly/models/insight-pages/wizard/model";
import {
  WizardConfiguration,
  WizardPropertiesConfiguration,
} from "@radarly/models/insight-pages/wizard/model/configuration";
import { useWizardConfigurationForm } from "./useWizardConfigurationForm";

export type Configuration = Omit<WizardConfiguration, "color" | "fields">;

export function useWizardAI({
  template,
  configuration,
  updateConfiguration,
}: {
  template: WizardTemplate;
  configuration: WizardConfiguration;
  updateConfiguration: (
    configuration: Pick<WizardConfiguration, "aiContext" | "includeAIAnalysis">
  ) => void;
}) {
  const locale = useCurrentUserLocale();
  const updateGlobalConfiguration = useCallback(
    (configuration: Configuration) => {
      updateConfiguration({
        ...configuration,
        aiContext: configuration.aiContext,
      });
    },
    [updateConfiguration]
  );

  const wizardConfiguration: WizardPropertiesConfiguration =
    useWizardConfigurationForm<Configuration>(
      {
        aiContext: configuration.aiContext,
      },
      updateGlobalConfiguration,
      template
    );

  return {
    ...wizardConfiguration,
    size: "m" as const,
    form: {
      aiContext: {
        placeholder: tr(
          locale,
          "CUSTOM_PAGES::EDITOR::DATAVIZ::MODAL_IP_DESCRIPTION::PLACEHOLDER"
        ),
      },
    },
  };
}
